module.exports = __webpack_public_path__ + "static/media/U1-T2-2-5b.06d046b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-5b.svg
// module id = 562
// module chunks = 0